import styled from 'styled-components';

export const FactsSectionComponent = styled.div`
    display: flex;
    font-size: 6rem;
    svg {
        margin: 20px auto;
        display: block;
    }
`;

export const FactsSectionTitle = styled.h2`
    padding: 60px 0 20px 0;
    margin: 0 auto;
    text-align: center;
    display: block;
    color: #343333;
    font-size: 30px;
    font-family: 'Oswald', sans-serif;
`;

export const FactTitle = styled.h3`
    font-size: 18px;
    font-family: 'Oswald', sans-serif;
    font-weight: 500;
    display: block;
    text-align: center;
    margin: 10px auto;
    color: #343333;
`;

export const FactDescription = styled.p`
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    display: block;
    text-align: center;
`;